import { render, staticRenderFns } from "./ExportMessage.vue?vue&type=template&id=1a9409e5&scoped=true&"
import script from "./ExportMessage.vue?vue&type=script&lang=js&"
export * from "./ExportMessage.vue?vue&type=script&lang=js&"
import style0 from "./ExportMessage.vue?vue&type=style&index=0&id=1a9409e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9409e5",
  null
  
)

export default component.exports